import React, { useEffect } from 'react';
import CreateRelationFrom from './CreateRelationFrom';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { clearCurrentRelation, getCurrentRelation } from 'redux/actions/RelationManager';
import { Card } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
    marginBottom: 6,
  },
}));

const CreateRelation = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const params = new URLSearchParams(location.search);

  const movieId = params.get('movie');
  const relationId = params.get('relation');

  const { currentRelation } = useSelector(({ relations }) => relations);

  useEffect(() => {
    if (relationId) {
      dispatch(getCurrentRelation(relationId));
    } else {
      dispatch(clearCurrentRelation);
    }
  }, [relationId, dispatch]);

  const breadcrumbs = [
    { label: 'لیست فیلم‌ها', link: '/' },
    { label: 'مدیریت رابطه', isActive: true },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs} heading={'مدیریت رابطه'}>
      <Card className={classes.cardRoot}>
        {!relationId ? (
          <CreateRelationFrom movieId={movieId} />
        ) : (
          currentRelation && <CreateRelationFrom relation={currentRelation} movieId={movieId} />
        )}
      </Card>
    </PageContainer>
  );
};

export default CreateRelation;
